export default function InputTheme() {
    return {
        overrides: {
            MuiInputBase: {
                input: {
                    fontSize: 16,
                },
                root: {
                    height: 56,
                },
            },
            MuiFilledInput: {
                root: {
                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                },
                underline: {
                    "&::before": {
                        borderBottom: "solid 2px #b2b2b2",
                    },
                    "&:hover::before": {
                        borderBottomWidth: "2px",
                    },
                },
            },
            MuiFormLabel: {
                root: {
                    fontSize: 16,
                    color: "rgba(0,0,0,0.6)",
                }
            },
            MuiFormHelperText: {
                root: {
                    marginTop: 0,
                    paddingTop: 0,
                },
            },
            MuiInputLabel: {
                shrink: {
                    color: "rgba(0,0,0,0.3) !important",
                },
            },
            MuiSelect: {
                fontSize: 16,
                icon: {
                    color: "rgba(0,0,0,1)"
                },
                iconFilled: {
                    right: 16,
                },
            },
            MuiAutocomplete: {
                endAdornment: {
                    display: "none"
                },
            },
        },
    };
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Helpers/InputTheme.js